/**
 * Viewport breakpoints for bullrun-web CSS and matchMedia hooks.
 * Names describe intent — always import these instead of hard-coded px values.
 *
 * Primary reference: native phone shell is the UX source of truth; 768px matches
 * `docs/eng-and-prod/bullrun-web-mobile-layout.md` (mobile IA router cutoff).
 */
export const BULLRUN_BREAKPOINTS = {
    /** ≤768px — mobile IA router (`MobileRouter`), same shell concept as bullrun-mobile phone. */
    mobileIaMaxPx: 768,
    /** ≤900px — dense discover / prediction layouts (desktop tree still active above 768). */
    narrowContentMaxPx: 900,
    /** ≤600px — marketing sections, ticker, very narrow desktop tweaks. */
    marketingNarrowMaxPx: 600,
    /** ≤1120px — top shell: collapse inline nav / search row (desktop `BullrunShell`). */
    headerCompactMaxPx: 1120,
    /** ≤1248px — tablet-oriented layout adjustments. */
    tabletMaxPx: 1248,
};
/** CSS media queries for styled-components object syntax, e.g. `[mqMobileIa]: { ... }`. */
export const mqMobileIa = `@media (max-width: ${BULLRUN_BREAKPOINTS.mobileIaMaxPx}px)`;
export const mqNarrowContent = `@media (max-width: ${BULLRUN_BREAKPOINTS.narrowContentMaxPx}px)`;
export const mqMarketingNarrow = `@media (max-width: ${BULLRUN_BREAKPOINTS.marketingNarrowMaxPx}px)`;
export const mqHeaderCompact = `@media (max-width: ${BULLRUN_BREAKPOINTS.headerCompactMaxPx}px)`;
export const mqTablet = `@media (max-width: ${BULLRUN_BREAKPOINTS.tabletMaxPx}px)`;
/** matchMedia strings (no `@media` wrapper) for hooks. */
export const matchMediaMobileIa = `(max-width: ${BULLRUN_BREAKPOINTS.mobileIaMaxPx}px)`;
export const matchMediaNarrowContent = `(max-width: ${BULLRUN_BREAKPOINTS.narrowContentMaxPx}px)`;
